import { render } from "./CardAttachmentMediaDialog.vue?vue&type=template&id=3625cdb4&scoped=true"
import script from "./CardAttachmentMediaDialog.vue?vue&type=script&lang=js"
export * from "./CardAttachmentMediaDialog.vue?vue&type=script&lang=js"

import "./CardAttachmentMediaDialog.vue?vue&type=style&index=0&id=3625cdb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3625cdb4"]])

export default __exports__